// extracted by mini-css-extract-plugin
export default {"alert":"ReferFraudMessage_alert__kgDU6","alertHdr":"ReferFraudMessage_alertHdr__nuv8H","detail":"ReferFraudMessage_detail__CJO0X","chatLink":"ReferFraudMessage_chatLink__CQ8Z2"};